import { render, staticRenderFns } from "./VesselVoyageHistoryCamera.vue?vue&type=template&id=2c4a79df&scoped=true&"
import script from "./VesselVoyageHistoryCamera.vue?vue&type=script&lang=js&"
export * from "./VesselVoyageHistoryCamera.vue?vue&type=script&lang=js&"
import style0 from "./VesselVoyageHistoryCamera.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VesselVoyageHistoryCamera.vue?vue&type=style&index=1&id=2c4a79df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a79df",
  null
  
)

export default component.exports